import React, { useState } from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
} from "antd";

import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";
import TravelEfficient from "../assets/images/travel1.svg";
import TravelEfficientTow from "../assets/images/travel2.svg";
import TravelEfficientThree from "../assets/images/travel3.svg";
import TravelEfficientFour from "../assets/images/travel4.svg";

import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";

import MegaMenu from "../components/MegaMenu";
import useActivityCategories from "../hooks/useActivityCategories";
import ImageCarousel from "../components/ImageCarousel";
import ViralThings from "../components/viralThings";
import ThingsToDoCard from "../components/ThingsToDoCard";
import TourCard from "../components/TourCard";
import ReviewSlider from "../components/ReviewSlider";
import { slideAllCategoryData } from "../data/slideAllCategoryData";
import { Spin } from "antd";
import TravelersFavoriteChoices from "../components/TravelersFavoriteChoices";
import FamilyFun from "../components/FamilyFun";
import RomanticSpots from "../components/RomanticSpots";
import ExploreTopMustDoThings from "../components/ExploreTopMustDoThings";
import SpatialOffers from "../components/SpatialOffers";
import ThingsToDoCardCountry from "../components/ThingsToDoCardCountry";
import TopAttractionsInDubaiCard from "../components/TopAttractionsInDubaiCard";
const { Text, Paragraph, Title } = Typography;

const ActivePage = () => {
  // Store selected by ID instead of index
  const [selectedTourId, setSelectedTourId] = useState(
    slideAllCategoryData[0].id,
  );

  // Find active tour
  const activeTour = slideAllCategoryData.find((t) => t.id === selectedTourId);
  const { categories, loading, error } = useActivityCategories();
  const [selectedTour, setSelectedTour] = useState(slideAllCategoryData[0]);

  // if (loading) return <p>Loading activities...</p>;
  // if (error) return <p>{error}</p>;

  // Show loading spinner
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" tip="Loading Activities..." />
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-red-600 py-10">{error}</div>;
  }

  return (
    <>
      <section className="bg-lightSky border border-solid border-[#CCE1F9] pt-6 pb-6">
        {loading ? (
          <div className="flex justify-center items-center py-10">
            <Spin size="large" tip="Loading activities..." />
          </div>
        ) : error ? (
          <p className="text-center text-red-600 py-10">{error}</p>
        ) : Array.isArray(categories) && categories.length > 0 ? (
          (() => {
            // ✅ Only use top-level products (categories) from the API

            const topLevelProducts = categories.map((product) => ({
              id: product.id,
              title: product.title || "Untitled Product",
              slug: product.slug || "",
              img:
                product.img ||
                "https://via.placeholder.com/400x250?text=No+Image",
              route: `/product/${product.slug || product.id}`,
              rating: product.rating,
              views: product.views,
            }));

            // ✅ Show carousel if products exist
            return topLevelProducts.length > 0 ? (
              <ImageCarousel
                slides={topLevelProducts}
                onSelect={setSelectedTour}
                parentTitle={"All Efficient Activities"}
              />
            ) : (
              <p className="text-center text-gray-500 py-8">
                No activity categories found.
              </p>
            );
          })()
        ) : (
          <p className="text-center text-gray-500 py-8">
            No activity categories found.
          </p>
        )}
      </section>

      {/* <section className="bg-lightSky border border-solid border-[#CCE1F9] pt-6 pb-8">
        {categories.length > 0 ? (
          <ImageCarousel slides={categories} onSelect={setSelectedTour} />
        ) : (
          <p>No activity categories found.</p>
        )}
      </section> */}
      {/* Special</span> Offers */}
      {/* <section className="pt-10 py-4 px-4 lg:px-0">
        <div className="container"> */}
      <section className="mt-4 py-4 px-4 lg:px-0">
        <div className="container">
          <TravelersFavoriteChoices />
        </div>
      </section>
      {/* </div>
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        <ViralThings />
      </section>
      {/* Family </span>  Fun */}
      <section className="py-4 px-4 lg:px-0">
        <FamilyFun />
      </section>

      {/* Romantic Spots  */}
      <section className="py-4 px-4 lg:px-0">
        <RomanticSpots />
      </section>

      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <Row gutter={[40, 20]}>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <ThingsToDoCard heading={"Top thing to do in Dubai"} />
            </Col>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <ThingsToDoCardCountry heading={"Top thing to do in UAE"} />
            </Col>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <TopAttractionsInDubaiCard heading={"Top Attractions in Dubai"} />
            </Col>
          </Row>
        </div>
      </section>

      <section className="py-4 px-4 lg:px-0">
        <div className="flex justify-center align-middle items-center mb-6 font-medium">
          <div>
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">Find Your Perfect</span> Travel
              Match
            </Title>
            <Paragraph className="!mb-0">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>
        </div>
        <div className="container">
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficient} preview={false} />
                <Title level={5}>Solo Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientTow} preview={false} />
                <Title level={5}>Couples Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientThree} preview={false} />
                <Title level={5}>Families Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientFour} preview={false} />
                <Title level={5}>Religious Visitors</Title>
              </Flex>
            </Col>
          </Row>
        </div>
      </section>

      <section className="py-4 px-4 lg:px-0">
        <div className="container">
        <ExploreTopMustDoThings />
        </div>
        
      </section>

      {/* <section className="py-4 px-4 lg:px-0">
        <div className="flex justify-center align-middle items-center mb-6 font-medium">
          <div>
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">
                Explore Top Must do things in{" "}
              </span>{" "}
              Dubai
            </Title>
            <Paragraph className="!mb-0">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>
        </div>
        <div className="container">
          <Row gutter={[30, 30]}>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>

          <Row gutter={[30, 30]} className="mt-8">
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>
        </div>
        <Flex justify="center" align="center" className="mt-10">
          <Button
            size="middle"
            type="default"
            className="font-semibold w-60 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-danger rounded-lg"
          >
            See More
          </Button>
        </Flex>
      </section> */}

      {/* <section className="py-6">
        <ReviewSlider />
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        {/* Header */}
        <div className="container">
          <div className="flex justify-between align-middle items-center mb-6">
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1"
              level={2}
            >
              <span className="text-primary">Spatial </span> Offers
            </Title>
          </div>
        </div>
        <div className="container">
          <SpatialOffers />
        </div>
      </section>
    </>
  );
};

export default ActivePage;
